import { useState } from "react";
import * as yup from "yup";

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "qualification") return isCreate ? "P" : data.qualification;
      if (fieldName === "period") return isCreate ? "-" : data.period;
      if (fieldName === "quantity") return isCreate ? 0 : data.quantity;
      if (fieldName === "isAttachmentRequired") return isCreate ? "N" : data.isAttachmentRequired ? "Y" : "N";

      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "code",
      "name",
      "absenceCode",
      "qualification",
      "period",
      "quantity",
      "isAttachmentRequired",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData);

  const dataIsValid = async () => {

    const codeRegex = /^[A-Z]+[A-Z0-9]*/;

    let schema = yup.object().shape({
      code: yup.string().matches(codeRegex).required(),
      name: yup.string().required(),
      absenceCode: yup.string().required(),
      qualification: yup.string().required(),
      period: yup.string().required(),
      quantity: yup.number().required(),
      isAttachmentRequired: yup.string().required(),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const submit = async () => {
    if (await dataIsValid()) {

      const dataToSend = {
        ...formData,
        isAttachmentRequired: formData.isAttachmentRequired !== "N",
      }

      isCreate ? createCallback(dataToSend) : modifyCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const formatValue = (value, fieldName) => {
    if (fieldName === "code") return value.length > 0 ? value.replace(/\s/g, "").toUpperCase() : "";
    if (fieldName === "quantity") return value.length > 0 ? parseInt(value) : "";
    return value;
  }

  const setFormValue = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: formatValue(value, fieldName),
    }));
  }

  return {
    isCreate,
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;